import { render, staticRenderFns } from "./ChartNotFound.vue?vue&type=template&id=29f9a5e4"
import script from "./ChartNotFound.vue?vue&type=script&lang=js"
export * from "./ChartNotFound.vue?vue&type=script&lang=js"
import style0 from "./ChartNotFound.vue?vue&type=style&index=0&id=29f9a5e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports